module.exports = __webpack_public_path__ + "static/media/solution_01.c3efe460.jpg";